import React, { Component } from 'react';
import globalControlStyles from '../GlobalControlsStyles';
import FlatButton from 'material-ui/FlatButton';
import { MENU_PANELS } from 'crazyEditor/core/constants/panelConstants';
import _ from 'lodash';
import { connect } from 'react-redux';
import { closeStaticPanel } from 'crazyEditor/redux/modules/panel/panel';
import styles from './SaveButtonStyles';
import TooltipWrapper from 'shared/components/TooltipWrapper';
import {getActionButtonProps} from 'MyAccount/Listings/consts';

const SAVE_BUTTON_PROPS = {
  secondary: true,
  style: globalControlStyles.buttonStyle,
  ...globalControlStyles.buttonProperties,
};

@connect(
  state => ({
    listingData: state.listingData,
    isTemplate: _.isEmpty(state.listingData),
  }), {closeStaticPanel}
)
export default class SaveButton extends Component {
  render() {
    const {isTemplate, onPrimaryActionClick, primaryAction} = this.props;
    const {tooltip, icon, ...buttonProps} = getActionButtonProps(primaryAction, {includeTooltip: true});
    return (
      <div>
        <TooltipWrapper
          tooltip={tooltip}
          popoverType="grey"
          anchorOrigin={{horizontal: 'middle', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'middle', vertical: 'top'}}
        >
          <FlatButton onClick={onPrimaryActionClick} {...buttonProps} {...SAVE_BUTTON_PROPS}
                      {...(!isTemplate ? styles.primaryButtonProperties : {})}
          />
        </TooltipWrapper>
      </div>
    );
  }
}
